import { PreapprovalPeriodType, RecurrencePeriodTypes } from '~/models/service-billing/model';
import * as serviceBillingModel from '~/models/service-billing/selectors';
export const billingPeriodTextsPath = 'billing';
export function preapprovalPeriodWordMap(texts) {
    return {
        [PreapprovalPeriodType.None]: '',
        [PreapprovalPeriodType.NoTimeLimit]: '',
        [PreapprovalPeriodType.Weekly]: texts.week(),
        [PreapprovalPeriodType.BiWeekly]: texts.twoWeeks(),
        [PreapprovalPeriodType.Monthly]: texts.month(),
        [PreapprovalPeriodType.Quarterly]: texts.quarter(),
        [PreapprovalPeriodType.Yearly]: texts.year()
    };
}
export function recurrencePeriodWordMap(texts) {
    return {
        [RecurrencePeriodTypes.Weekly]: texts.week(),
        [RecurrencePeriodTypes.BiWeekly]: texts.twoWeeks(),
        [RecurrencePeriodTypes.Monthly]: texts.month(),
        [RecurrencePeriodTypes.Quarterly]: texts.quarter(),
        [RecurrencePeriodTypes.Yearly]: texts.year()
    };
}
function recurrenceFrequencyWordMap(texts) {
    return {
        [RecurrencePeriodTypes.Weekly]: texts.weekly(),
        [RecurrencePeriodTypes.BiWeekly]: texts.everyTwoWeeks(),
        [RecurrencePeriodTypes.Monthly]: texts.monthly(),
        [RecurrencePeriodTypes.Quarterly]: texts.quarterly(),
        [RecurrencePeriodTypes.Yearly]: texts.yearly()
    };
}
export function recurrenceFrequencyWord(period, texts) {
    return recurrenceFrequencyWordMap(texts)[period];
}
export function preapprovalPeriodWord(period, texts) {
    return preapprovalPeriodWordMap(texts)[period];
}
export function recurrencePeriodWord(period, texts) {
    return recurrencePeriodWordMap(texts)[period];
}
export function extendedRecurrencePeriodWord(period, texts) {
    if (period === 'onetime' || period === 'inStages' || period === 'onDemand') return '';
    return recurrencePeriodWordMap(texts)[period];
}
export function recurrencePeriodSlashSuffix(period, texts) {
    const word = extendedRecurrencePeriodWord(period, texts);
    return word ? texts.slashSuffix({
        period: word
    }) : '';
}
function preapprovalPeriodVerbMap(texts) {
    return {
        [PreapprovalPeriodType.None]: texts.requires(),
        [PreapprovalPeriodType.NoTimeLimit]: texts.requires(),
        [PreapprovalPeriodType.Weekly]: texts.requires(),
        [PreapprovalPeriodType.BiWeekly]: texts.willRequire(),
        [PreapprovalPeriodType.Monthly]: texts.requires(),
        [PreapprovalPeriodType.Quarterly]: texts.requires(),
        [PreapprovalPeriodType.Yearly]: texts.requires()
    };
}
export function billingPeriodWord(billing, texts) {
    const recurrenceWord = (recurring)=>recurrencePeriodWordMap(texts)[recurring.recurrencePeriod] || null;
    const noPeriod = ()=>null;
    return serviceBillingModel.match(billing, {
        onApproval: noPeriod,
        ongoing: recurrenceWord,
        repeatableManual: recurrenceWord,
        oneTimeManual: noPeriod,
        oneTimeInStages: noPeriod,
        onDemand: (onDemand)=>preapprovalPeriodWordMap(texts)[onDemand.preapprovalPeriod] || null
    });
}
export function billingPeriodSlashSuffix(billing, texts) {
    if (!billing) return '';
    const word = billingPeriodWord(billing, texts);
    return word ? texts.slashSuffix({
        period: word
    }) : '';
}
export function preapprovalPeriodVerb(period, texts) {
    return preapprovalPeriodVerbMap(texts)[period];
}
